export const getEvents = async () => {
  try {
    const response = await fetch("http://guynorth.com:3000/events", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const responseData = await response.json();
    return responseData.data;
  } catch (error) {
    console.error("Failed to get events");
  }
  return [];
};
